module.exports = __webpack_public_path__ + "static/koa-general-framework-docs-2fdbb36cf9cd546f0ef3066a9457156f.png";